"use strict";

var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DataStorage = void 0;
var _tsRes = require("ts-res"),
  _kameleoonError = require("../kameleoonError"),
  _integrityChecker = require("./integrityChecker"),
  _logging = require("../logging");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var DataStorage = /*#__PURE__*/function () {
  function DataStorage(a, b) {
    _classCallCheck(this, DataStorage);
    _defineProperty(this, "externalStorage", void 0), _defineProperty(this, "storageKey", void 0), this.externalStorage = a, this.storageKey = b;
    var c = new _integrityChecker.IntegrityChecker(b),
      d = this.read();
    if (!d.ok) {
      if (d.error.type === _kameleoonError.KameleoonException.StorageEmpty) {
        var _a = c.getDefaultData();
        this.write(_a);
      }
      return;
    }
    var e = d.data;
    if (!c.isDataValid(e)) {
      var _a2 = c.getDefaultData();
      this.write(_a2);
    }
  }
  return _createClass(DataStorage, [{
    key: "read",
    value: function read() {
      try {
        var a = this.externalStorage.read(this.storageKey);
        return null === a ? (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.StorageEmpty)) : (0, _tsRes.Ok)(a);
      } catch (_) {
        return _logging.KameleoonLogger.error(_templateObject || (_templateObject = _taggedTemplateLiteral(["Failed to read data from storage: ", ""])), this.storageKey), (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.StorageRead, this.storageKey));
      }
    }
  }, {
    key: "write",
    value: function write(a) {
      try {
        return this.externalStorage.write(this.storageKey, a), (0, _tsRes.Ok)();
      } catch (_) {
        return _logging.KameleoonLogger.error(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Failed to write data to storage: ", ""])), this.storageKey), (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.StorageWrite, this.storageKey));
      }
    }
  }, {
    key: "update",
    value: function update(a) {
      var b = this.read();
      if (!b.ok) return b.error.type === _kameleoonError.KameleoonException.StorageEmpty ? this.write(a) : b;
      var c = b.data;
      var d;
      return d = "string" == typeof c ? a : _objectSpread(_objectSpread({}, c), a), this.write(d);
    }
  }]);
}();
exports.DataStorage = DataStorage;